import { useMemo } from "react";
import type { Entity } from "@common/types/entity";
import { EntityAvatar } from "@components/avatar/EntityAvatar";
import { getEntityAvatarName } from "@helpers/entityAvatarName";
import { useEntitiesContexts } from "@hooks/useEntitiesContexts";
import {
    MAX_ENTITY_REF_OPTIONS,
    NO_ENTITY_REF_OPTIONS,
    type EntityRefOption,
    type EntityRefOptionsParams,
    type EntityRefOptionsResult,
} from "./entityRefOptions.types";

function toEntityOption(entity: Entity): EntityRefOption {
    const title = getEntityAvatarName(entity);
    return {
        key: `entity:${entity.uuid}`,
        entityRef: { kind: "entity", id: entity.uuid, label: title },
        icon: <EntityAvatar entity={entity} size="xs" aria-hidden />,
        title,
    };
}

export function useEntityKindRefOptions({
    query,
    isEnabled,
}: EntityRefOptionsParams): EntityRefOptionsResult {
    const contexts = useEntitiesContexts();

    return useMemo(() => {
        if (!isEnabled) {
            return NO_ENTITY_REF_OPTIONS;
        }
        const normalizedQuery = query.trim().toLowerCase();
        const options = (contexts ?? [])
            .map((context) => context.entity)
            .filter((entity) =>
                getEntityAvatarName(entity)
                    .toLowerCase()
                    .includes(normalizedQuery),
            )
            .slice(0, MAX_ENTITY_REF_OPTIONS)
            .map(toEntityOption);
        return { options, isLoading: contexts === undefined };
    }, [isEnabled, contexts, query]);
}
